var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("calendar-main", {
    attrs: {
      "add-permission": _vm.hasAddPermission,
      "delete-event": _vm.deleteEvent,
      "delete-permission": _vm.hasDeletePermission,
      "edit-permission": _vm.hasEditPermission,
      "get-categories": _vm.getCategories,
      "get-events": _vm.getEvents
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }